"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = exports.theme = void 0;
var styled_media_helper_1 = __importDefault(require("styled-media-helper"));
var breakpoints = styled_media_helper_1.default({
    sm: 320,
    md: 768,
    lg: 1240
});
exports.breakpoints = breakpoints;
var theme = {
    main: 'mediumseagreen',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    shadow: '0px 0px 6px 1px rgba(0, 0, 0, 0.2);',
    gradient: 'linear-gradient(90deg, rgb(0, 31, 86) 0%, rgb(3, 18, 52) 100%)',
    colors: {
        primary: 'rgb(0, 69, 103)',
        secondary: 'rgb(255, 192, 0)',
        lightgray: 'rgb(240,240,240)'
    }
};
exports.theme = theme;
//# sourceMappingURL=theme.js.map